import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { mockData } from "../mock";

export const Contact = () => {
  const handleWhatsAppContact = () => {
    const message = encodeURIComponent("Olá! Gostaria de mais informações.");
    window.open(
      `https://wa.me/${mockData.company.whatsapp}?text=${message}`,
      "_blank"
    );
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-slate-50 to-blue-50 py-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Entre em Contato
          </h1>
          <p className="text-xl text-gray-600">
            Estamos prontos para atender você e transformar seu projeto em
            realidade
          </p>
        </div>
      </section>

      {/* Contact Info */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            <Card className="hover:shadow-lg transition-shadow">
              <CardContent className="p-6 text-center">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-blue-100 text-blue-600 rounded-full mb-4">
                  <Phone size={24} />
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Telefone</h3>
                <a
                  href={`tel:${mockData.company.phone}`}
                  className="text-gray-600 hover:text-blue-600 transition-colors"
                >
                  {mockData.company.phone}
                </a>
              </CardContent>
            </Card>

            <Card className="hover:shadow-lg transition-shadow">
              <CardContent className="p-6 text-center">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-green-100 text-green-600 rounded-full mb-4">
                  <Mail size={24} />
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">E-mail</h3>
                <a
                  href={`mailto:${mockData.company.email}`}
                  className="text-gray-600 hover:text-blue-600 transition-colors break-all"
                >
                  {mockData.company.email}
                </a>
              </CardContent>
            </Card>

            <Card className="hover:shadow-lg transition-shadow">
              <CardContent className="p-6 text-center">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-purple-100 text-purple-600 rounded-full mb-4">
                  <MapPin size={24} />
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Endereço</h3>
                <p className="text-gray-600 text-sm">
                  {mockData.company.address}
                </p>
              </CardContent>
            </Card>

            <Card className="hover:shadow-lg transition-shadow">
              <CardContent className="p-6 text-center">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-orange-100 text-orange-600 rounded-full mb-4">
                  <Clock size={24} />
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Horário</h3>
                <p className="text-gray-600 text-sm">
                  Seg - Sex: 8h às 18h
                  <br />
                  Sáb: 8h às 12h
                </p>
              </CardContent>
            </Card>
          </div>

          {/* CTA Card */}
          <Card className="bg-gradient-to-br from-blue-50 to-slate-50 border-none shadow-lg">
            <CardContent className="p-12 text-center">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Solicite Seu Orçamento
              </h2>
              <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
                Entre em contato conosco através do WhatsApp para receber um
                orçamento personalizado sem compromisso. Resposta rápida
                garantida!
              </p>
              <Button
                onClick={handleWhatsAppContact}
                size="lg"
                className="bg-green-500 hover:bg-green-600 text-lg px-8 py-6"
              >
                <Phone size={20} className="mr-2" />
                Falar no WhatsApp
              </Button>
            </CardContent>
          </Card>
        </div>
      </section>

      {/* Map Section (Placeholder) */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Nossa Localização
            </h2>
            <p className="text-lg text-gray-600">
              Atendemos toda a região metropolitana de São Paulo
            </p>
          </div>

          <div className="bg-gray-200 rounded-lg h-96 flex items-center justify-center">
            <div className="text-center text-gray-500">
              <MapPin size={48} className="mx-auto mb-4" />
              <p className="text-lg font-medium">Mapa de Localização</p>
              <p className="text-sm">{mockData.company.address}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
